<template>
    <div
            class="d2-layout-header-aside-group"
            :style="styleLayoutMainGroup"
            :class="{grayMode: grayActive}">
        <!-- 半透明遮罩 -->
        <div class="d2-layout-header-aside-mask"></div>
        <!-- 主体内容 -->
        <div class="d2-layout-header-aside-content" flex="dir:top">
            <!-- 顶栏 -->
            <div
                    class="d2-theme-header d2-theme-header-backgroud-image_top"
                    :style="{
          opacity: this.searchActive ? 0.5 : 1
        }"
                    style="background-color:#1D9DE1;"
                    flex-box="0"
                    flex>
                <div class="logo-group" style="text-align:left;padding-left:20px;" :style="{width: asideCollapse ? asideWidthCollapse : asideWidth}" flex-box="1">
                    <img v-if="asideCollapse" :src="`${$baseUrl}image/theme/${themeActiveSetting.name}/logo/all.png`"
                    >
                    <img v-else :src="`${$baseUrl}image/theme/${themeActiveSetting.name}/logo/all.png`">
                </div>

                <!-- <div class="toggle-aside-btn" @click="handleToggleAside" flex-box="0">
                  <d2-icon name="bars"/>
                </div> -->

                <!-- <d2-menu-header flex-box="1"/> -->
                <!-- 顶栏右侧 -->
                <div class="d2-header-right" flex-box="0">
                    <!-- 如果你只想在开发环境显示这个按钮请添加 v-if="$env === 'development'" -->
                    <!-- <d2-header-search @click="handleSearchClick"/> -->
                    <!-- <d2-header-log/> -->
                    <el-button class="d2-mr btn-text can-hover" type="text" @click="onShowMessageContainer">
                        <el-badge :value="mailCount" class="item" v-if="mailCount > 0">
                            <d2-icon name="bell" style="font-size: 18px;color:#fff;"/>
                        </el-badge>
                        <d2-icon name="bell" style="font-size: 18px;color:#fff;" v-if="mailCount === 0"/>
                    </el-button>
                    <el-button class="d2-mr btn-text can-hover" type="text" @click="goHome">
                        <d2-icon name="home" style="font-size: 18px;color:#fff;"/>
                    </el-button>
                    <d2-header-fullscreen/>
                    <!-- <d2-header-theme/> -->
                    <d2-header-size/>
                    <!-- <d2-header-locales/>  关闭国际化 -->
                    <!-- <d2-header-color/> -->
                    <d2-header-user/>
                </div>
            </div>
            <!-- 自己写的导航 -->

            <div class="d2-theme-header d2-theme-header-backgroud-image_bottom" style="overflow-x: auto;overflow-y: hidden;"  flex-box="0" flex>
                <headerMenu></headerMenu>
            </div>
            <!-- 下面 主体 -->
            <div class="d2-theme-container" flex-box="1" flex>
                <!-- 主体 侧边栏 -->
                <div
                        flex-box="0"
                        ref="aside"
                        class="d2-theme-container-aside"
                        style="background:rgb(23, 67, 99)"
                        :style="{
            width: asideCollapse ? asideWidthCollapse : asideWidth,
            opacity: this.searchActive ? 0.5 : 1
          }">
                    <d2-menu-side v-if="menus"/>
                </div>
                <!-- 主体 -->
                <div class="d2-theme-container-main" flex-box="1" flex>
                    <!-- 搜索 -->
                    <!-- <transition name="fade-scale">
                      <div v-if="searchActive" class="d2-theme-container-main-layer" flex>
                        <d2-panel-search
                          ref="panelSearch"
                          @close="searchPanelClose"/>
                      </div>
                    </transition> -->
                    <!-- 内容 -->
                    <transition name="fade-scale">
                        <div v-if="!searchActive" class="d2-theme-container-main-layer" flex="dir:top">
                            <!-- tab -->
                            <div class="d2-theme-container-main-header" flex-box="0">
                                <d2-tabs/>
                            </div>
                            <!-- 页面 -->
                            <div class="d2-theme-container-main-body" flex-box="1">
                                <transition :name="transitionActive ? 'fade-transverse' : ''">
                                    <keep-alive :include="keepAlive">
                                        <router-view />
                                    </keep-alive>
                                </transition>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>

        <el-dialog :visible.sync="dialogMessageVisible" :close-on-click-modal="false" width="80%">
            <div v-if="dialogMessageVisible" style="width: 100%;height: 650px;overflow: hidden;display: flex;">
                <notices-show v-if="dialogMessageVisible"></notices-show>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import GlobalEvent from '@/plugin/Events/GlobalEvent'
    import d2MenuSide from './components/menu-side'
    import d2MenuHeader from './components/menu-header'
    import headerMenu from './components/menu-header/headerMenu'
    import d2Tabs from './components/tabs'
    import d2HeaderFullscreen from './components/header-fullscreen'
    import d2HeaderLocales from './components/header-locales'
    import d2HeaderSearch from './components/header-search'
    import d2HeaderSize from './components/header-size'
    import d2HeaderTheme from './components/header-theme'
    import d2HeaderUser from './components/header-user'
    import d2HeaderLog from './components/header-log'
    import d2HeaderColor from './components/header-color'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import mixinSearch from './mixins/search'
    import globalEvent from "@/components/GlobalEvent";
    import Test from "@/views/Test";
    import NoticesShow from '@/views/system/controllers/notices/notices-show'
    export default {
        name: 'd2-layout-header-aside',
        mixins: [
            mixinSearch
        ],
        components: {
            NoticesShow,
            d2MenuSide,
            //d2MenuHeader,
            headerMenu,
            d2Tabs,
            d2HeaderFullscreen,
            //d2HeaderLocales,
            //d2HeaderSearch,
            d2HeaderSize,
            //d2HeaderTheme,
            d2HeaderUser,
            //d2HeaderLog,
            // d2HeaderColor
        },
        data () {
            return {
                // [侧边栏宽度] 正常状态
                asideWidth: '220px',
                // [侧边栏宽度] 折叠状态
                asideWidthCollapse: '0px',
                menus: true,
                newMessage: false,
                mailCount: 0,
                dialogMessageVisible: false,
                timeIndex: 0
            }
        },
        computed: {
            ...mapState('d2admin', {
                keepAlive: state => state.page.keepAlive,
                grayActive: state => state.gray.active,
                transitionActive: state => state.transition.active,
                asideCollapse: state => state.menu.asideCollapse
            }),
            ...mapGetters('d2admin', {
                themeActiveSetting: 'theme/activeSetting'
            }),
            /**
             * @description 最外层容器的背景图片样式
             */
            styleLayoutMainGroup () {
                return {
                    ...this.themeActiveSetting.backgroundImage ? {
                        backgroundImage: `url('${this.$baseUrl}${this.themeActiveSetting.backgroundImage}')`
                    } : {}
                }
            }
        },
        methods: {
            ...mapActions('d2admin/menu', [
                'asideCollapseToggle'
            ]),
            /**
             * 接收点击切换侧边栏的按钮
             */
            handleToggleAside () {
                this.asideCollapseToggle()
            },
            goHome(){
                this.$router.push('/system')
            },
            onShowMessageContainer(){
                this.dialogMessageVisible = true;
                console.log(11);
            },
            messageStatusRefresh(){
                let $this = this
                clearTimeout(this.timeIndex)
                try {
                    this.$http.post("",this,$url.homeNotices.status,{}).then(res=>{
                        console.log(res);
                        const { data } = res
                        $this.mailCount = data['unread']
                    })
                    // this.$http.postX(this.$url.notices,{}).then(response=>{
                    //     const { data } = response
                    //     $this.mailCount = data['unread']
                    // })
                }catch (e) {

                }
                this.timeIndex = setTimeout(()=>{
                    $this.messageStatusRefresh()
                }, 5 * 60 * 1000)
            }
        },
        mounted() {
            let $this = this
            globalEvent.onMenuRerander(()=>{
                $this.menus = false
                $this.$nextTick(()=>{
                    $this.menus = true
                })
            })
            this.messageStatusRefresh()
            GlobalEvent.mail.on(this.messageStatusRefresh)
        },

    }
</script>

<style lang="scss">
    // 注册主题
    @import '~@/assets/style/theme/register.scss';
    .el-menu-item,.el-submenu{
        // border-bottom: 1px solid #cecece;
        // border-top: 1px solid #cecece;
    }
    .theme-d2 .d2-theme-container .d2-theme-container-aside .el-menu .el-menu-item{
        color: #fff;
    }
    /*左侧菜单点击样式*/
    .theme-d2 .d2-theme-container .d2-theme-container-aside .el-menu .el-menu-item.is-active{
        color: #fff;
        border-left: 4px solid white;
        background-color: rgba(76, 160, 230, 0.8);
    }
    /*左侧菜单hover样式*/
    .theme-d2 .d2-theme-container .d2-theme-container-aside .el-menu .el-menu-item:hover{
        color: #fff !important;
        background-color: rgba(76, 160, 230, 0.8) !important;
    }
    /*左侧菜单常态字体样式*/
    .theme-d2 .d2-theme-container .d2-theme-container-aside .el-submenu .el-submenu__title{
        color: #ffffff;
    }
    /*左侧菜单hover字体样式+背景样式*/
    .theme-d2 .d2-theme-container .d2-theme-container-aside .el-submenu .el-submenu__title:hover{
        color: #ffffff;
        background-color: rgba(76, 160, 230, 0.8) !important;
    }
    /*左侧菜单图标hover颜色*/
    .theme-d2 .d2-theme-container .d2-theme-container-aside .el-submenu .el-submenu__title:hover .el-submenu__icon-arrow{
        color: #fff;
    }
    /*左侧菜单图标常态颜色*/
    .theme-d2 .d2-theme-container .d2-theme-container-aside .el-submenu .el-submenu__title .el-submenu__icon-arrow{
        color: #ffffff;
    }
    /*顶部背景样式*/
    .d2-theme-header-backgroud-image_top{//背景栏
        background-image:linear-gradient(to bottom,rgb(15, 48, 88),rgb(41, 118, 212));
    }
    .d2-theme-header-backgroud-image_bottom{//菜单栏
        background-image:linear-gradient(to bottom,rgb(41,118,212),rgb(57,146,208));
        padding-bottom: 8px;
        height: 45px !important;
    }
    /**设置下拉滚动条样式**/
    .d2-layout-header-aside-content .d2-theme-header-backgroud-image_bottom::-webkit-scrollbar{
        width: 2px;
        // border-radius:5px;
    }
    .d2-layout-header-aside-content .d2-theme-header-backgroud-image_bottom::-webkit-scrollbar-track{
        width: 1px;
        // border-radius:5px;
        box-sizing: border-box;
    }
    .d2-layout-header-aside-content .d2-theme-header-backgroud-image_bottom::-webkit-scrollbar-thumb{
        background-color: rgba(255, 255, 255, 0.548);
        // border-radius:5px;
    }
    .d2-layout-header-aside-content .d2-theme-header-backgroud-image_bottom::-webkit-scrollbar{
        // display: none;
        height: 10px;
    }
    /*无侧边菜单栏样式*/
    .d2-layout-header-aside-menu-side .d2-layout-header-aside-menu-empty:hover{//背景
        background-color: rgb(23, 67, 99) !important;
    }
    .d2-layout-header-aside-menu-side .d2-layout-header-aside-menu-empty{//背景
        background-color: rgb(23, 67, 99) !important;
    }
    .d2-layout-header-aside-menu-side .d2-layout-header-aside-menu-empty i{//图标
        color: #a4a5a7 !important;
    }
    .d2-layout-header-aside-menu-side .d2-layout-header-aside-menu-empty span{//字体
        color: #a4a5a7 !important;
    }

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/layout.vue"
}
</vue-filename-injector>
